import { useRouter } from 'vue-router'

export const useJump = () => {
    const router = useRouter()
    const jump2Policy = () => {
        router.push('/policy')
    }

    const jump2Privacy = () => {
        router.push('/privacy')
    }
    return {
        jump2Policy,
        jump2Privacy
    }
}
